import React, { useEffect, useState } from "react";

const WeeklyBarChart = ({ data, averageLine }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAnimate(true);
    }, 100); // slight delay to allow render before animating
    return () => clearTimeout(timeout);
  }, []);

  const values = data?.map((d) => d.totalEntries);
  const maxValue = Math.max(...values);

  const avgValue = Math.round(
    values?.reduce((sum, val) => sum + val, 0) / values?.length
  );

  return (
    <div className="w-full max-w-5xl mx-auto p-4 mb-[200px]">
      <div className="relative h-56 flex items-end gap-3">
        {/* Rolling average line */}
        {/* <div
          className="absolute left-0 w-full border-t-4 border-blue-400 z-10"
          style={{ bottom: `${(avgValue / maxValue) * 100}%` }}
        >
          <p className="absolute top-[-26px]  right-0">Average</p>
        </div> */}

        <div
          className="absolute left-0 w-full border-t-4 border-blue-400 z-10 group"
          style={{ bottom: `${(avgValue / maxValue) * 100}%` }}
        >
          <p className="absolute top-[-26px] right-0 cursor-pointer">
            Average
            {/* Tooltip */}
            <span
              className="absolute left-1/2 -translate-x-1/2 -top-8 
        bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity"
            >
              {/* {averageLine.toFixed(2)} */}
              {Math.round(averageLine)}
            </span>
          </p>
        </div>

        {/* Bars */}
        {data?.map((item, index) => {
          const heightPercent = (item?.totalEntries / maxValue) * 100;
          let barColor = "bg-[#e6f2e3]";
          if (item?.totalEntries === avgValue) barColor = "bg-[#ef9c8f]";
          else if (item?.totalEntries < avgValue) barColor = "bg-[#ef9c8f]";

          return (
            <div
              key={index}
              className="flex flex-col w-full items-center justify-end relative"
              style={{ height: "100%" }}
            >
              {heightPercent > 0 && (
                <div
                  className={`w-16 ${barColor} rounded-md transition-all duration-700 ease-out`}
                  style={{
                    height: animate ? `${heightPercent}%` : `0%`,
                    minHeight: animate ? "10px" : "0px",
                  }}
                ></div>
              )}
            </div>
          );
        })}
      </div>

      {/* Value and label row */}
      <div className="mt-4 flex justify-between gap-3 px-2">
        {data?.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center w-full"
          >
            <div className="text-2xl mb-2 font-extrabold">
              {item?.totalEntries}
            </div>
            <div className="text-xs font-medium text-center">
              {item?.weekendDates}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeeklyBarChart;
